const {createSlice} = require('@reduxjs/toolkit');

const slice = createSlice({
  name: 'assetClass',
  initialState: {
    bondInstruments: {},
    mutualFundsInstruments: {},
    mutualFunds: {},
    bonds: {},
    ipo: {},
    ipoInstruments: {},
    equity: {},
    equityInstruments: {},
    groupedInstruments: {},
  },
  reducers: {
    handleBondsInstrumentState: (state, action) => {
      state.bondInstruments = {
        ...state.bondInstruments,
        ...action.payload,
      };
    },
    handleBondsFieldState: (state, action) => {
      state.bonds = {
        ...state.bonds,
        ...action.payload,
      };
    },
    handleMutualFundsInstruments: (state, action) => {
      state.mutualFundsInstruments = {
        ...state.mutualFundsInstruments,
        ...action.payload,
      };
    },
    handleIpoFieldState: (state, action) => {
      state.ipo = {...state.ipo, ...action.payload};
    },
    handleIpoInstruments: (state, action) => {
      state.ipoInstruments = {...state.ipoInstruments, ...action.payload};
    },
    handleEquityFieldState: (state, action) => {
      state.equity = {...state.equity, ...action.payload};
    },
    handleEquityInstruments: (state, action) => {
      state.equityInstruments = {...state.equityInstruments, ...action.payload};
    },
    handleMutualFunds: (state, action) => {
      state.mutualFunds = {
        ...state.mutualFunds,
        ...action.payload,
      };
    },
    handleUpdateGroupedInstruments: (state, action) => {
      state.groupedInstruments = {
        ...state.groupedInstruments,
        ...action.payload,
      };
    },
    handleClearGroupedInstruments: state => {
      state.groupedInstruments = {};
    },
    handleClearBondsState: state => {
      state.bonds = {};
      state.bondInstruments = {};
    },
    handleClearMutualFundsState: state => {
      state.mutualFunds = {};
      state.mutualFundsInstruments = {};
    },
    handleClearIpoState: state => {
      state.ipo = {};
      state.ipoInstruments = {};
    },
    handleClearEquityState: state => {
      state.equity = {};
      state.equityInstruments = {};
    },
  },
});

export default slice.reducer;

export const {
  handleBondsInstrumentState,
  handleClearBondsState,
  handleClearMutualFundsState,
  handleMutualFunds,
  handleMutualFundsInstruments,
  handleUpdateGroupedInstruments,
  handleClearGroupedInstruments,
  handleBondsFieldState,
  handleIpoFieldState,
  handleIpoInstruments,
  handleEquityFieldState,
  handleEquityInstruments,
  handleClearIpoState,
  handleClearEquityState,
} = slice.actions;
